import { useGetCompanyReviews } from '@entities/companyReview';
import { PaginateType } from '@shared/types';
import { ReviewsPreview } from '@shared/ui';
import { CompanyReviewCard } from './CompanyReviewCard';

type CompanyReviewsProps = {
  companyId: number;
};

const PREVIEW_COUNT = 3;

export const CompanyReviews = ({ companyId }: CompanyReviewsProps) => {
  const { data, isLoading } = useGetCompanyReviews(
    {
      filter: {
        companyId: { items: [companyId], operator: 'or' },
      },
      sort: {
        reviewAt: 'desc',
      },
      paginate: PaginateType.DEFAULT,
      perPage: PREVIEW_COUNT,
    },
    Boolean(companyId)
  );

  return (
    <ReviewsPreview
      data={data}
      isLoading={isLoading}
      previewCount={PREVIEW_COUNT}
      viewAllHref={`/reviews?tab=candidate-reviews&companyId=${companyId}`}
      renderCard={review => <CompanyReviewCard review={review} />}
    />
  );
};
